module.exports = __webpack_public_path__ + "static/premium-web@2x-3710f7aa23b4683d528d41e9363aa470.webp";